// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-items-form[data-v-e67284b0] {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.list-items-form .edit-actions[data-v-e67284b0] {\n  display: flex;\n  gap: 10px;\n  flex: 1;\n}\n.list-items-form .edit-actions *[data-v-e67284b0] {\n  flex: 1;\n}", ""]);
// Exports
module.exports = exports;
